import ExcelJS from 'exceljs';
import moment from 'moment';

const EmergencyContactsExcel = async (reportData: any, formData: any) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Emergency Contacts');

    // Add Main Title
    worksheet.mergeCells('A1:E1');
    const titleCell = worksheet.getCell('A1');
    titleCell.value = 'Emergency Contacts Report';
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    titleCell.font = { size: 18, bold: true };

    // Add sub-info (Report Date)
    worksheet.mergeCells('A2:B2');

    let currentRow = 4;

    // Define Columns and Headers
    const headers = [
        'Employee Name',
        'Contact 1 Name',
        'Contact 1 Cell',
        'Contact 2 Name',
        'Contact 2 Cell'
    ];

    const headerRow = worksheet.getRow(currentRow);
    headerRow.values = headers;
    headerRow.font = { bold: true };
    headerRow.height = 20;

    // Header Styling
    headerRow.eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F2F2F2' }
        };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        };
    });

    currentRow++;

    // Sorting the data by Last Name
    const sortedData = Array.isArray(reportData) ? [...reportData].sort((a: any, b: any) => {
        const nameA = (a.LASTNAME || '').toUpperCase();
        const nameB = (b.LASTNAME || '').toUpperCase();
        return nameA.localeCompare(nameB);
    }) : [];

    // Add Data Rows
    sortedData.forEach((item: any) => {
        const row = worksheet.addRow([
            `${item.LASTNAME || ''}, ${item.FIRSTNAME || ''}`,
            item.emernamE1 || '-',
            item.emercelL1 || '-',
            item.emernamE2 || '-',
            item.emercelL2 || '-'
        ]);

        row.eachCell((cell) => {
            cell.alignment = { horizontal: 'left', vertical: 'middle', indent: 1 };
            cell.border = {
                top: { style: 'thin', color: { argb: 'FFD3D3D3' } },
                left: { style: 'thin', color: { argb: 'FFD3D3D3' } },
                bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } },
                right: { style: 'thin', color: { argb: 'FFD3D3D3' } }
            };
        });

        currentRow++;
    });

    // Adjust column widths
    worksheet.columns = [
        { width: 35 }, // Employee Name
        { width: 30 }, // Contact 1 Name
        { width: 20 }, // Contact 1 Cell
        { width: 30 }, // Contact 2 Name
        { width: 20 }  // Contact 2 Cell
    ];

    // Freeze the header row
    worksheet.views = [
        { state: 'frozen', xSplit: 0, ySplit: 4 }
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    return buffer;
};

export default EmergencyContactsExcel;
